import { TextField, InputAdornment } from "@mui/material";
import { Icon } from "@iconify/react";

import { Strings } from "@app/constants"; 

import { SearchBoxProps } from "../../types";
import { RHFTextField } from "@app/components";

const SearchBox = () => (
  <RHFTextField 
  name="search"
  size="small"
  placeholder={Strings.common.search}
  onKeyDown={(e) => {
      if (e.key === "Enter") {
        e.preventDefault();
      }
    }}
  InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <Icon
            icon="mdi:magnify"
            width={20}
            height={20}
            style={{ color: "#666" }}
          />
        </InputAdornment>
      ),
    }}
  ></RHFTextField>
);

export { SearchBox };
